// Import all resort JSON files
// Updated with new image URLs and amenities data - TRAV23-3524
import cubRiverLodgeGuestRanch from './cub-river-lodge-guest-ranch.json';
import campingStValere from './camping-st-valere.json';
import cherryGroveCampground from './cherry-grove-campground.json';
import deerwoodInnMadisonCampground from './deerwood-inn-madison-campground.json';
import elGolfoBeachResortCra from './el-golfo-beach-resort-cra.json';
import martinLakeResort from './martin-lake-resort.json';
import champsRvResort from './champs-rv-resort.json';
import ghostMountainRanchCra from './ghost-mountain-ranch-cra.json';
import carefreeManorRvResort from './carefree-manor-rv-resort.json';
import rondoutValleyResort from './rondout-valley-resort.json';
import cherryValleyLakesResort from './cherry-valley-lakes-resort.json';
import lostValleyLakeResort from './lost-valley-lake-resort.json';
import lakesideRvResort from './lakeside-rv-resort.json';
import bigCedarCampground from './big-cedar-campground.json';
import monticelloRvPark from './monticello-rv-park.json';
import lakeshoreBlissResort from './lakeshore-bliss-resort.json';
import heritageAcresRvPark from './heritage-acres-rv-park.json';
import jamarTravelPark from './jamar-travel-park.json';
import kmResortsOfAmericaColumbiaShoresResort from './km-resorts-of-america-columbia-shores-resort.json';
import cascadeMeadowsRvResort from './cascade-meadows-rv-resort.json';
import campingDeCompton from './camping-de-compton.json';
import sunsetKingLakeResort from './sunset-king-lake-resort.json';
import otterFallsCutoff from './otter-falls-cutoff.json';
import blancaRvPark from './blanca-rv-park.json';
import kmDiamondPointResort from './km-diamond-point-resort.json';
import silentValleyClub from './silent-valley-club.json';
import riverRiseResort from './river-rise-resort.json';
import heartlandWoodsFamilyResort from './heartland-woods-family-resort.json';
import hiddenValleyRanch from './hidden-valley-ranch.json';
import backeddyResortAndMarina from './backeddy-resort-and-marina.json';
import sunshineRvResort from './sunshine-rv-resort.json';
import eaglesLandingRvResortRecreation from './eagles-landing-rv-resort-recreation.json';
import ranchoPinesCampground from './rancho-pines-campground.json';
import willowBranchRvPark from './willow-branch-rv-park.json';
import barnettResortsLlcDbaOspreyPointRvResort from './barnett-resorts-llc-dba-osprey-point-rv-resort.json';
import forestHillsGolfRvResort from './forest-hills-golf-rv-resort.json';
import kmMapleGroveResort from './km-maple-grove-resort.json';
import candyCaneRvParkAndCampground from './candy-cane-rv-park-and-campground.json';
import camperlandRvResort from './camperland-rv-resort.json';
import lakeGeorgeCampsites from './lake-george-campsites.json';
import quietOaksRvPark from './quiet-oaks-rv-park.json';
import driftwoodRvFishingResort from './driftwood-rv-fishing-resort.json';
import peacefulWindsRvPark from './peaceful-winds-rv-park.json';
import patoBlancoLakesRvResort from './pato-blanco-lakes-rv-resort.json';
import salemWoodsTrailerPark from './salem-woods-trailer-park.json';
import waldenwoodsFamilyRecreationResort from './waldenwoods-family-recreation-resort.json';
import prideRvResortMaggieValley from './pride-rv-resort-maggie-valley.json';
import anzaRvResort from './anza-rv-resort.json';
import mileZeroPark from './mile-zero-park.json';
import blueMesaRecreationalRanch from './blue-mesa-recreational-ranch.json';
import applegateTrailRvPark from './applegate-trail-rv-park.json';
import tomCarolsRvPark from './tom-carols-rv-park.json';
import osullivanSportsmansResort from './osullivan-sportsmans-resort.json';
import wallyWorldRiversideResort from './wally-world-riverside-resort.json';
import cascadePeaksFamilyCampground from './cascade-peaks-family-campground.json';
import stonyBrookRecreationAndCamping from './stony-brook-recreation-and-camping.json';
import ridgeviewRvResortCra from './ridgeview-rv-resort-cra.json';
import kqRanchResortCra from './kq-ranch-resort-cra.json';
import sundance1RvResort from './sundance-1-rv-resort.json';
import hiddenValleyRvPark from './hidden-valley-rv-park.json';
import saratogaEscapeLodgesRvResort from './saratoga-escape-lodges-rv-resort.json';
import shadyGroveCampground from './shady-grove-campground.json';
import kmOceanBreezeRvResort from './km-ocean-breeze-rv-resort.json';
import alaskaCanoeCampgrounds from './alaska-canoe-campgrounds.json';
import goldenPondRvPark from './golden-pond-rv-park.json';
import blueRidgeFallsCampsite from './blue-ridge-falls-campsite.json';
import lakefieldCampgrounds from './lakefield-campgrounds.json';
import kmTravelInnResort from './km-travel-inn-resort.json';
import sundanceCampgroundAndRvPark from './sundance-campground-and-rv-park.json';
import alleganyMountainResort from './allegany-mountain-resort.json';
import lakeHarmonyRvPark from './lake-harmony-rv-park.json';
import zuniVillageRvPark from './zuni-village-rv-park.json';
import arrowheadRvPark from './arrowhead-rv-park.json';
import sunshineVillageManufacturedHomeCommunityRvRe from './sunshine-village-manufactured-home-community-rv-re.json';
import willowBayResortMarina from './willow-bay-resort-marina.json';
import sunriseResortsLakeEaston from './sunrise-resorts-lake-easton.json';
import lakeEastonResortSr from './lake-easton-resort-sr.json';
import portIsabelParkCenterInc from './port-isabel-park-center-inc.json';
import lakeHavasuResortCra from './lake-havasu-resort-cra.json';
import sunriseResortsPacificHolidayResort from './sunrise-resorts-pacific-holiday-resort.json';
import sunriseAdventuresRidgeviewCra from './sunrise-adventures-ridgeview-cra.json';
import arreyRvPark from './arrey-rv-park.json';
import macgavinsQueenValleyRvResort from './macgavins-queen-valley-rv-resort.json';
import aaRoyalMotelCampground from './aa-royal-motel-campground.json';
import whisperingPinesCampground from './whispering-pines-campground.json';
import millbrookOutdoorResort from './millbrook-outdoor-resort.json';
import canyonCreekResort from './canyon-creek-resort.json';
import sunriseResortsPier4 from './sunrise-resorts-pier-4.json';
import moultrieRvPark from './moultrie-rv-park.json';
import rioRvParkAtTurtleBayou from './rio-rv-park-at-turtle-bayou.json';
import riverViewCampgroundCanoeLivery from './river-view-campground-canoe-livery.json';
import councilCupCampground from './council-cup-campground.json';
import kmOldAmericanKampgroundResort from './km-old-american-kampground-resort.json';
import conestogaCampgroundRvPark from './conestoga-campground-rv-park.json';
import southernTrailsRvResort from './southern-trails-rv-resort.json';
import ramseyRvPark from './ramsey-rv-park.json';
import twinValleyCampground from './twin-valley-campground.json';
import bearRiverRvPark from './bear-river-rv-park.json';
import countrySunshineRvPark from './country-sunshine-rv-park.json';
import sycamoreLodgeResort from './sycamore-lodge-resort.json';
import roaringRunResort from './roaring-run-resort.json';
import terraStarrRvPark from './terra-starr-rv-park.json';
import lookoffFamilyCampingResort from './lookoff-family-camping-resort.json';
import cowboyCapitalCampground from './cowboy-capital-campground.json';
import burroMountainHomestead from './burro-mountain-homestead.json';
import redBarnCampground from './red-barn-campground.json';
import rockGlenFamilyResort from './rock-glen-family-resort.json';
import windRiverViewCampgrounds from './wind-river-view-campgrounds.json';
import highPlainsCampround from './high-plains-campround.json';
import riverboatTravelPark from './riverboat-travel-park.json';
import whitneyResorts from './whitney-resorts.json';
import emeraldCoveResortCra from './emerald-cove-resort-cra.json';
import bayViewRvResort from './bay-view-rv-resort.json';
import lazyDayCampground from './lazy-day-campground.json';
import grandCountryRvPark from './grand-country-rv-park.json';
import niagarasLazyLakesCampingResort from './niagaras-lazy-lakes-camping-resort.json';
import countryLaneCampground from './country-lane-campground.json';
import mountainVillageRvPark from './mountain-village-rv-park.json';
import parnellCreekRvPark from './parnell-creek-rv-park.json';
import babyNuggetRvPark from './baby-nugget-rv-park.json';
import campColdbrookRvResort from './camp-coldbrook-rv-resort.json';
import pineLakeRvPark from './pine-lake-rv-park.json';
import epsomValleyCampground from './epsom-valley-campground.json';
import yumaLakesResortCra from './yuma-lakes-resort-cra.json';
import gettysburgBattlefieldResort from './gettysburg-battlefield-resort.json';
import downataHotSprings from './downata-hot-springs.json';
import riversEdgeRvCampground from './rivers-edge-rv-campground.json';
import breckenridgeLakeRvCampground from './breckenridge-lake-rv-campground.json';

// Export all resorts as an array
export const allResorts = [
  cubRiverLodgeGuestRanch,
  campingStValere,
  cherryGroveCampground,
  deerwoodInnMadisonCampground,
  elGolfoBeachResortCra,
  martinLakeResort,
  champsRvResort,
  ghostMountainRanchCra,
  carefreeManorRvResort,
  rondoutValleyResort,
  cherryValleyLakesResort,
  lostValleyLakeResort,
  lakesideRvResort,
  bigCedarCampground,
  monticelloRvPark,
  lakeshoreBlissResort,
  heritageAcresRvPark,
  jamarTravelPark,
  kmResortsOfAmericaColumbiaShoresResort,
  cascadeMeadowsRvResort,
  campingDeCompton,
  sunsetKingLakeResort,
  otterFallsCutoff,
  blancaRvPark,
  kmDiamondPointResort,
  silentValleyClub,
  riverRiseResort,
  heartlandWoodsFamilyResort,
  hiddenValleyRanch,
  backeddyResortAndMarina,
  sunshineRvResort,
  eaglesLandingRvResortRecreation,
  ranchoPinesCampground,
  willowBranchRvPark,
  barnettResortsLlcDbaOspreyPointRvResort,
  forestHillsGolfRvResort,
  kmMapleGroveResort,
  candyCaneRvParkAndCampground,
  camperlandRvResort,
  lakeGeorgeCampsites,
  quietOaksRvPark,
  driftwoodRvFishingResort,
  peacefulWindsRvPark,
  patoBlancoLakesRvResort,
  salemWoodsTrailerPark,
  waldenwoodsFamilyRecreationResort,
  prideRvResortMaggieValley,
  anzaRvResort,
  mileZeroPark,
  blueMesaRecreationalRanch,
  applegateTrailRvPark,
  tomCarolsRvPark,
  osullivanSportsmansResort,
  wallyWorldRiversideResort,
  cascadePeaksFamilyCampground,
  stonyBrookRecreationAndCamping,
  ridgeviewRvResortCra,
  kqRanchResortCra,
  sundance1RvResort,
  hiddenValleyRvPark,
  saratogaEscapeLodgesRvResort,
  shadyGroveCampground,
  kmOceanBreezeRvResort,
  alaskaCanoeCampgrounds,
  goldenPondRvPark,
  blueRidgeFallsCampsite,
  lakefieldCampgrounds,
  kmTravelInnResort,
  sundanceCampgroundAndRvPark,
  alleganyMountainResort,
  lakeHarmonyRvPark,
  zuniVillageRvPark,
  arrowheadRvPark,
  sunshineVillageManufacturedHomeCommunityRvRe,
  willowBayResortMarina,
  sunriseResortsLakeEaston,
  lakeEastonResortSr,
  portIsabelParkCenterInc,
  lakeHavasuResortCra,
  sunriseResortsPacificHolidayResort,
  sunriseAdventuresRidgeviewCra,
  arreyRvPark,
  macgavinsQueenValleyRvResort,
  aaRoyalMotelCampground,
  whisperingPinesCampground,
  millbrookOutdoorResort,
  canyonCreekResort,
  sunriseResortsPier4,
  moultrieRvPark,
  rioRvParkAtTurtleBayou,
  riverViewCampgroundCanoeLivery,
  councilCupCampground,
  kmOldAmericanKampgroundResort,
  conestogaCampgroundRvPark,
  southernTrailsRvResort,
  ramseyRvPark,
  twinValleyCampground,
  bearRiverRvPark,
  countrySunshineRvPark,
  sycamoreLodgeResort,
  roaringRunResort,
  terraStarrRvPark,
  lookoffFamilyCampingResort,
  cowboyCapitalCampground,
  burroMountainHomestead,
  redBarnCampground,
  rockGlenFamilyResort,
  windRiverViewCampgrounds,
  highPlainsCampround,
  riverboatTravelPark,
  whitneyResorts,
  emeraldCoveResortCra,
  bayViewRvResort,
  lazyDayCampground,
  grandCountryRvPark,
  niagarasLazyLakesCampingResort,
  countryLaneCampground,
  mountainVillageRvPark,
  parnellCreekRvPark,
  babyNuggetRvPark,
  campColdbrookRvResort,
  pineLakeRvPark,
  epsomValleyCampground,
  yumaLakesResortCra,
  gettysburgBattlefieldResort,
  downataHotSprings,
  riversEdgeRvCampground,
  breckenridgeLakeRvCampground,
];
